var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"TransportBox"}},[_c('div',{staticClass:"bordered-box"},[_c('div',[_c('div',[_c('font-awesome-icon',{staticClass:"icon-style",attrs:{"icon":['fas', _vm.icon],"size":"5x"}})],1),_c('div',{staticClass:"text"},[_c('label',[_vm._v(_vm._s(_vm.text))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }